import { type ICouponRepository, type IDeleteCouponUseCase, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for deleting a given coupon.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for deleting a coupon
 */
export function deleteCouponUseCase(couponRepository: ICouponRepository): IDeleteCouponUseCase {
  return {
    execute: ({ couponId, couponIndex }): ReturnType<IDeleteCouponUseCase['execute']> => {
      const isDeleted = couponRepository.deleteCoupon({ couponId, couponIndex });

      if (!isDeleted) {
        throw new NotFoundError(`No entity found for couponId: ${couponId}, couponIndex: ${couponIndex}`);
      }

      return Promise.resolve(isDeleted);
    },
  };
}
